/*
* Custom error validator used for section forms
Format for setting rule
const v = {
    fname: { empty: "Please Enter First Name" },
    lname: { empty: "Please Enter Last Name" },
    profession: { empty: "Please Enter Profession" },
    city: { empty: "Please Enter City" },
    // state: { empty: "Please Enter State" },
    zipcode: {
      empty: "Please Enter Zip Code",
      other1: {
        msg: "Please Enter Valid Zip",
        validator: val => !(/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(val))
      }
    },
    phone: {
      empty: "Please Enter Phone Number",
      other1: {
        msg: "Please Enter Valid Phone Number",
        validator: val => {
          const phonereg = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/
          return !phonereg.test(val)
        }
      }
    },
    email: {
      empty: "Please Enter Email Address",
      other1: {
        msg: "Please Enter Valid Email Address",
        validator: val => !(/\S+@\S+\.\S+/.test(val))
      }
    },
  };

*/

class ErrorValidator {
  constructor(v) {
    this.ruleSet = v
  }
  validateFields = (data, field = '') => {
    if (field.length) data = { [field]: data }
    let errorsmsg = {};
    const inputs = field ? [field] : Object.keys(this.ruleSet)
    // debugger
    inputs.forEach(input => {

      if (this.ruleSet.hasOwnProperty(input) && data.hasOwnProperty(input)) {
        const field_value = (typeof str === 'string') ? data[input].trim() : data[input]
        //Check all validators
        for (let [key, value] of Object.entries(this.ruleSet[input])) {
          // console.log(key, value);
          if (key == 'empty') {
            if (!field_value.length) errorsmsg[input] = value
          } else if (value.validator(field_value)) {
            errorsmsg[input] = value.msg
          }
        }
      } else {
        console.log('Field not found in validator set.')
      }
    })
    return errorsmsg;
  };
}
export default ErrorValidator;